import { useState, useCallback } from 'react'
import { listReportAttendanceSummaryAPI } from '../../../services/report/attendanceSum'

const cleanParams = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== '' && v !== null && v !== undefined
    )
  )

export default function useReportAttendanceSummary() {
  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  const fetchAttendanceSummary = useCallback(async (params) => {
    setIsLoading(true)
    try {
      const result = await listReportAttendanceSummaryAPI(cleanParams(params))
      if (result?.status) {
        setData(result.result?.data ?? [])
        setTotal(result.result?.totalRows ?? 0)
      }
    } catch (error) {
      console.error('fetchAttendanceSummary error:', error)
    } finally {
      setIsLoading(false)
    }
  }, [])

  return {
    data,
    total,
    isLoading,
    fetchAttendanceSummary
  }
}
